module.exports = __webpack_public_path__ + "assets/img/icono-telefono-b2.svg";